<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Return Card",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Return Card",
      items: [
        {
          text: "Home",
        },
         {
          text: "Settings",
        },
        {
          text: "Return Card",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>